import React from 'react';
import { Grid, GridProps } from '@cp/ds/src/components/grid';
import { CityCatalogStatsResponse } from '@common/model/catalog/item/cityStatsRequest';
import { CareerId } from '@common/const/catalog/career';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { styled } from '@cp/ds/src/theme';
import { CareerDictionaryResponse } from '../api';
import { CareerTile } from './tile';

const Root = styled(Grid)(({ theme }) => ({
  flexWrap: 'wrap',
  paddingInline: theme.spacing(2.5),
  [theme.breakpoints.up('md')]: {
    paddingInline: 0,
  },
}));

export interface CareerGridProps extends GridProps {
  stats?: CityCatalogStatsResponse;
  catalogType?: CatalogItemType;
  careerDictionary?: CareerDictionaryResponse;
  loading?: boolean;
  onCareerSelect: (careerId: CareerId, event: React.MouseEvent) => void;
}
export const CareerGrid: React.FC<CareerGridProps> = ({
  stats,
  careerDictionary,
  loading,
  catalogType = CatalogItemType.Resume,
  onCareerSelect,
  ...props
}) => {
  const items = React.useMemo(
    () => Object.entries({ ...careerDictionary }).map(([careerId, careerViewModel]) => [Number(careerId), careerViewModel] as const),
    [careerDictionary],
  );

  return (
    <Root container spacing={1} {...props}>
      {items.map(([careerId, careerViewModel]) => (
        <Grid item key={careerId} sx={{ display: 'flex' }} xs={6}>
          <CareerTile
            careerId={careerId}
            catalogStats={
              stats?.[careerId]?.[catalogType]
                ? {
                    count: stats[careerId][catalogType]?.totalCount ?? 0,
                    catalogType,
                  }
                : undefined
            }
            disabled={loading || !careerViewModel.isActive}
            label={careerViewModel.translation.namePlural}
            onClick={(e) => onCareerSelect(careerId, e)}
          />
        </Grid>
      ))}
    </Root>
  );
};
